/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesLookupRelationType } from './WebApiModelsEnumerationTypesLookupRelationType';
import {
    WebApiModelsEnumerationTypesLookupRelationTypeFromJSON,
    WebApiModelsEnumerationTypesLookupRelationTypeFromJSONTyped,
    WebApiModelsEnumerationTypesLookupRelationTypeToJSON,
} from './WebApiModelsEnumerationTypesLookupRelationType';
import type { WebApiModelsEnumerationTypesUiControl } from './WebApiModelsEnumerationTypesUiControl';
import {
    WebApiModelsEnumerationTypesUiControlFromJSON,
    WebApiModelsEnumerationTypesUiControlFromJSONTyped,
    WebApiModelsEnumerationTypesUiControlToJSON,
} from './WebApiModelsEnumerationTypesUiControl';

/**
 * 
 * @export
 * @interface WebApiModelsCustomListField
 */
export interface WebApiModelsCustomListField {
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsCustomListField
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsCustomListField
     */
    listId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsCustomListField
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsCustomListField
     */
    nameAdmin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsCustomListField
     */
    namePublic?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiModelsCustomListField
     */
    visibleInAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiModelsCustomListField
     */
    visiblePublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiModelsCustomListField
     */
    mandatoryAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiModelsCustomListField
     */
    mandatoryPublic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsCustomListField
     */
    helpTextAdmin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsCustomListField
     */
    helpTextPublic?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsCustomListField
     */
    columnOrder?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesUiControl}
     * @memberof WebApiModelsCustomListField
     */
    uiControl?: WebApiModelsEnumerationTypesUiControl;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsCustomListField
     */
    alternatives?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsCustomListField
     */
    lookupListId?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesLookupRelationType}
     * @memberof WebApiModelsCustomListField
     */
    lookupRelationType?: WebApiModelsEnumerationTypesLookupRelationType;
}

/**
 * Check if a given object implements the WebApiModelsCustomListField interface.
 */
export function instanceOfWebApiModelsCustomListField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiModelsCustomListFieldFromJSON(json: any): WebApiModelsCustomListField {
    return WebApiModelsCustomListFieldFromJSONTyped(json, false);
}

export function WebApiModelsCustomListFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsCustomListField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'listId': !exists(json, 'listId') ? undefined : json['listId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'nameAdmin': !exists(json, 'nameAdmin') ? undefined : json['nameAdmin'],
        'namePublic': !exists(json, 'namePublic') ? undefined : json['namePublic'],
        'visibleInAdmin': !exists(json, 'visibleInAdmin') ? undefined : json['visibleInAdmin'],
        'visiblePublic': !exists(json, 'visiblePublic') ? undefined : json['visiblePublic'],
        'mandatoryAdmin': !exists(json, 'mandatoryAdmin') ? undefined : json['mandatoryAdmin'],
        'mandatoryPublic': !exists(json, 'mandatoryPublic') ? undefined : json['mandatoryPublic'],
        'helpTextAdmin': !exists(json, 'helpTextAdmin') ? undefined : json['helpTextAdmin'],
        'helpTextPublic': !exists(json, 'helpTextPublic') ? undefined : json['helpTextPublic'],
        'columnOrder': !exists(json, 'columnOrder') ? undefined : json['columnOrder'],
        'uiControl': !exists(json, 'uiControl') ? undefined : WebApiModelsEnumerationTypesUiControlFromJSON(json['uiControl']),
        'alternatives': !exists(json, 'alternatives') ? undefined : json['alternatives'],
        'lookupListId': !exists(json, 'lookupListId') ? undefined : json['lookupListId'],
        'lookupRelationType': !exists(json, 'lookupRelationType') ? undefined : WebApiModelsEnumerationTypesLookupRelationTypeFromJSON(json['lookupRelationType']),
    };
}

export function WebApiModelsCustomListFieldToJSON(value?: WebApiModelsCustomListField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'listId': value.listId,
        'companyId': value.companyId,
        'nameAdmin': value.nameAdmin,
        'namePublic': value.namePublic,
        'visibleInAdmin': value.visibleInAdmin,
        'visiblePublic': value.visiblePublic,
        'mandatoryAdmin': value.mandatoryAdmin,
        'mandatoryPublic': value.mandatoryPublic,
        'helpTextAdmin': value.helpTextAdmin,
        'helpTextPublic': value.helpTextPublic,
        'columnOrder': value.columnOrder,
        'uiControl': WebApiModelsEnumerationTypesUiControlToJSON(value.uiControl),
        'alternatives': value.alternatives,
        'lookupListId': value.lookupListId,
        'lookupRelationType': WebApiModelsEnumerationTypesLookupRelationTypeToJSON(value.lookupRelationType),
    };
}

